function userSessionExists(){
  return document.querySelector('#user_session').dataset.exists == 'true'
}

function userWasInvited(){
  return document.querySelector('#user_origin').dataset.invitation == 'true'
}

export { userSessionExists, userWasInvited };
